import { signal } from '@angular/core';

export const isLoadingSignal = signal(false);

export const showLoading = (): void => {
  isLoadingSignal.set(true);
};

export const hideLoading = (delayMs = 300): void => {
  setTimeout(() => {
    isLoadingSignal.set(false);
  }, delayMs);
};
